import detector from "detector";

function isFacebookApp() {
    const ua = navigator.userAgent || navigator.vendor;
    return ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1;
}

const isSupportedBrowser = () => {
    let isSupported = "yes";
    let supportMessage = "";
    const { browser, os } = detector;

    if (
        browser.name === "ie" ||
        browser.name === "edge" ||
        (typeof Promise === "undefined" && (Promise as any).toString().indexOf("[native code]") === -1)
    ) {
        supportMessage = "browsername";
        isSupported = "no";
    } else if (os.name === "ios" && os.version < 10) {
        supportMessage = "osversion";
        isSupported = "no";
    } else if (browser.name === "chrome" && browser.version < 72) {
        supportMessage = "browserversion";
        isSupported = "warn";
    } else if (browser.name === "firefox" && browser.version < 68) {
        supportMessage = "browserversion";
        isSupported = "warn";
    } else if (browser.name === "safari" && browser.version < 13) {
        supportMessage = "browserversion";
        isSupported = "warn";
    } else if (os.name === "ios" && os.version < 12) {
        supportMessage = "osversion";
        isSupported = "warn";
    } else if (os.name === "android" && os.version < 6) {
        supportMessage = "osversion";
        isSupported = "warn";
    } else if (
        browser.name !== "chrome" &&
        browser.name !== "firefox" &&
        browser.name !== "safari" &&
        !isFacebookApp()
    ) {
        supportMessage = "browser";
        isSupported = "warn";
    }

    return {
        isSupported,
        supportMessage 
    } as {
        isSupported: string,
        supportMessage: "expired" |
            "unauthorized" |
            "reload" |
            "browserversion" |
            "osversion" |
            "browser"
    };
};

export default isSupportedBrowser;
